import {
    SET_MERGE_VALUE
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_MERGE_VALUE:
            return {
                ...state,
                SUBMIT_loading: false,
                message: action.message,
            }
        default:
            return state
    }
}